import { getDefaultStore } from 'jotai';
import { currentPracticeAtom } from '../../lib/practice';
import Practice from './practice';

export default class Zorgmail {

  // NOTE: This reads `currentPracticeAtom` from the jotai default store (one-shot
  // read, not a subscription). Call sites must themselves subscribe to
  // `currentPracticeAtom` (via `useAtom`) so they re-render on practice changes;
  // otherwise the module check here may be evaluated against a stale practice.
  static can_check_zorgmail = (login) => {
    let can_check_zorgmail = false;
    if (!!login && login.type === "User::Coach") can_check_zorgmail = true;
    if (!!login && login.type === "User::Restricted") can_check_zorgmail = true;

    if (!!can_check_zorgmail) {
      const currentPractice = getDefaultStore().get(currentPracticeAtom);
      can_check_zorgmail = !!Practice.practice_modules_v3({practice: currentPractice, check: 'zorg_mail'});
    }

    return can_check_zorgmail
  };

  static zorgmail_initialised = (login) => {
    let all_okay = false;
    if (!!login && login.type === "User::Coach" && !!login.extra_data.zorgmail) {
      all_okay = (!!login.extra_data.zorgmail.username && !!login.extra_data.zorgmail.password);
    }

    return all_okay
  };
}
